declare namespace $ {

	type $shm_hitalama_entergate_internal_form__pending_login_shm_hitalama_entergate_internal_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entergate_internal['pending_login'] >
		,
		ReturnType< $shm_hitalama_entergate_internal_form['pending_login'] >
	>
	export class $shm_hitalama_entergate_internal extends $shm_hitalama_entergate {
		pending_login( next?: string ): string
		Form( ): $shm_hitalama_entergate_internal_form
	}
	
	type $mol_view__sub_shm_hitalama_entergate_internal_form_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_entergate_internal_form extends $shm_hitalama_entergate_form {
		pending_login( next?: string ): string
		sub( ): readonly(any)[]
		Title( ): $mol_view
	}
	
}

//# sourceMappingURL=internal.view.tree.d.ts.map